import React from "react";
import helperStyles from "@src/components/helpers.module.scss";
import useSvgFillColor from "@src/hooks/useSvgFillColor";

const DownloadIcon = () => {
	const fillColor = useSvgFillColor();

	return (
		<div className={helperStyles.iconContainer}>
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8 10V2" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
					stroke={fillColor}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.6665 6.66602L7.99984 9.99935L11.3332 6.66602"
					stroke={fillColor}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};

export default DownloadIcon;
